import { FirebaseApp, FirebaseOptions } from "@firebase/app-types";
import { FirebaseFirestore, CollectionReference, Settings } from "@firebase/firestore-types";
import { FirebaseAuth, User } from "@firebase/auth-types";
import firebase from "@firebase/app";
import "@firebase/storage";
import "@firebase/firestore";
import "@firebase/functions";
import "@firebase/auth";

// firebase init goes here
// const config: FirebaseOptions = {
//   apiKey: "AIzaSyCjR6xHxsR6dOER5XG_w-80R08I2vUxNog",
//   authDomain: "wishify-v0.firebaseapp.com",
//   databaseURL: "https://wishify-v0.firebaseio.com",
//   projectId: "wishify-v0",
//   storageBucket: "wishify-v0.appspot.com",
// };

const config: FirebaseOptions = {
  apiKey: process.env.VUE_APP_apiKey,
  authDomain: process.env.VUE_APP_authDomain,
  databaseURL: process.env.VUE_APP_databaseURL,
  projectId: process.env.VUE_APP_projectId,
  storageBucket: process.env.VUE_APP_storageBucket,
};

const HTTP_CALLABLE_TIMEOUT = 120 * 1000;

const fbApp: FirebaseApp = firebase.initializeApp(config);

// firebase utils
// using Non-Null Assertion Operators cause of Typescript errors
const db: FirebaseFirestore = fbApp.firestore!();

const auth: FirebaseAuth = fbApp.auth();
const currentUser: User = auth.currentUser!;

const googleAuthProvider = new (firebase.auth as any).GoogleAuthProvider();

const facebookAuthProvider = new (firebase.auth as any).FacebookAuthProvider();

// Create a storage reference from our storage service
const appStorage = fbApp.storage();
const storageRef = appStorage.ref();

const fbFunctions = fbApp.functions();

// for GC functions debugging on localhost
// fbFunctions.useFunctionsEmulator("http://localhost:5000");

const scrapeImages = fbFunctions.httpsCallable("scrapeWebImages", {timeout: HTTP_CALLABLE_TIMEOUT});

// date issue fix according to firebase
const settings: Settings = {
    timestampsInSnapshots: true,
};
db.settings(settings);

// firebase collections
// const usersCollection: CollectionReference = db.collection("users");

export {
    fbApp,
    db,
    auth,
    currentUser,
    googleAuthProvider,
    facebookAuthProvider,
    storageRef,
    fbFunctions,
    scrapeImages,
    // usersCollection
};
